<template>
  <a-drawer
    :maskClosable="false"
    width="45%"
    :label-col="4"
    :wrapper-col="14"
    :visible="innerVisible"
    @close="handleClose"
    :destroyOnClose="true"
    title="选择代理租户"
  >
    <div class="table-page-search-wrapper">
      <a-form layout="inline" labelAlign="right">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="代理商名称">
              <a-input v-model="query.name" placeholder="请输入" allow-clear @keyup.enter="handleQuery" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="联系人">
              <a-input v-model="query.contacts" placeholder="请输入" allow-clear @keyup.enter="handleQuery" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="状态">
              <a-select placeholder="请选择" v-model="query.status" style="width: 100%" allow-clear>
                <a-select-option :value="0">正常</a-select-option>
                <a-select-option :value="1">异常关闭</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div style="margin-bottom: 16px">
      <a-button type="primary" @click="confirmSelect">确认选择</a-button>
    </div>
    <a-table
      :loading="loading"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :pagination="pagination"
      @change="handleTableChange"
      :row-selection="{
        type: 'radio',
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
    >
      <span slot="status" slot-scope="text, record">
        <a-tag :color="record.status === 0 ? 'green' : 'red'">
          {{ record.status === 0 ? '正常' : '异常关闭' }}
        </a-tag>
      </span>
    </a-table>
  </a-drawer>
</template>

<script>
import { listTenant } from '@/api/system/tenant'

export default {
  name: 'AgentSelectDrawer',
  props: {
    // 保留 visible prop 以支持双向绑定方式（可选）
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      innerVisible: false, // 内部控制的显示状态
      currentSelectedId: undefined, // 当前选中的ID
      loading: false,
      list: [],
      selectedRowKeys: [],
      selectedRow: null,
      query: {
        pageNum: 1,
        pageSize: 10,
        type: 2, // 2表示代理商
        name: '',
        contacts: '',
        status: undefined,
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      },
      columns: [
        {
          title: '代理商名称',
          dataIndex: 'name',
          key: 'name',
          ellipsis: true,
        },
        {
          title: '联系人',
          dataIndex: 'contacts',
          key: 'contacts',
          ellipsis: true,
        },
        {
          title: '联系电话',
          dataIndex: 'mobile',
          key: 'mobile',
          ellipsis: true,
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          scopedSlots: { customRender: 'status' },
        },
      ],
    }
  },
  watch: {
    // 支持通过 prop 控制（可选，兼容旧用法）
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.initDrawer()
      }
    },
    // 同步内部状态到外部（如果使用 prop 方式）
    innerVisible(newVal) {
      if (!newVal) {
        this.$emit('update:visible', false)
      }
    },
  },
  methods: {
    // 打开抽屉（命令式调用）
    open(selectedId) {
      this.currentSelectedId = selectedId
      this.innerVisible = true
      this.initDrawer()
    },
    // 关闭抽屉（命令式调用）
    close() {
      this.handleClose()
    },
    // 初始化抽屉
    initDrawer() {
      this.resetQuery()
      this.resetSelection()
      this.getList()
    },
    // 重置选中状态
    resetSelection() {
      this.selectedRowKeys = []
      this.selectedRow = null
    },
    // 查询列表
    handleQuery() {
      this.query.pageNum = 1
      this.getList()
    },
    // 重置查询条件
    resetQuery() {
      this.query = {
        pageNum: 1,
        pageSize: 10,
        type: 2,
        name: '',
        contacts: '',
        status: undefined,
      }
      this.pagination.current = 1
    },
    // 获取代理商列表
    getList() {
      this.loading = true
      listTenant(this.query)
        .then((res) => {
          if (res.success && res.data) {
            this.list = res.data.records || []
            this.pagination.total = res.data.total || 0
            this.pagination.current = res.data.current || 1
            this.pagination.pageSize = res.data.size || 10
          } else {
            this.list = []
            this.pagination.total = 0
          }
          this.loading = false
          // 如果有预设的选中ID，在数据加载后初始化选中状态
          if (this.currentSelectedId && this.list.length > 0) {
            this.$nextTick(() => {
              this.initSelected()
            })
          }
        })
        .catch(() => {
          this.list = []
          this.pagination.total = 0
          this.loading = false
        })
    },
    // 初始化选中状态
    initSelected() {
      if (this.currentSelectedId) {
        const matchedRow = this.list.find((item) => item.id === this.currentSelectedId)
        if (matchedRow) {
          this.selectedRowKeys = [matchedRow.id]
          this.selectedRow = matchedRow
        }
      }
    },
    // 表格变化
    handleTableChange(pagination) {
      this.query.pageNum = pagination.current
      this.query.pageSize = pagination.pageSize
      this.getList()
    },
    // 选择变化
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRow = selectedRows.length > 0 ? selectedRows[0] : null
    },
    // 确认选择
    confirmSelect() {
      if (!this.selectedRow) {
        this.$message.warning('请选择一个代理租户')
        return
      }
      this.$emit('confirm', this.selectedRow)
      this.handleClose()
    },
    // 关闭抽屉
    handleClose() {
      this.innerVisible = false
      this.resetSelection()
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-page-search-submitButtons {
  display: flex;
  align-items: center;
}
</style>
